// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.pricelisteditor', {
        url:'/editor',
        views: {"wideColumnView@product": {
            templateUrl: 'main/product/pricelisteditor/pricelisteditor.tpl.html',
            controller: 'PriceListEditorController as vm'
        }}
    });
}

// @ngInject
function PriceListEditorController($scope) {
    var vm = this;

    //Properties
    vm.selectedArticleIds = [];
    vm.selectedArticleCollectionId = null;
    vm.selectedSalesChannelId = null;

    //Methods
    vm.searchContextChanged = searchContextChanged;

    activate();

    function activate() {
    }

    function searchContextChanged(searchContext) {
        vm.selectedArticleCollectionId = searchContext.articleCollectionId;
        vm.selectedArticleIds = searchContext.articleIds;
        vm.selectedSalesChannelId = searchContext.saleschannelId;
    }

}

angular
    .module('product.priceListEditor', [])
    .config(stateConfig)
    .controller('PriceListEditorController', PriceListEditorController);
